// lib
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ADND from '@aytm/lib/adnd/ADND'

// styles
import style from '@aytm/app/stats/page/xperts-debug/JsonFileUpload.module.scss'

const processUploadedFile = async files =>
  new Promise((resolve, reject) => {
    const file = files[0]
    const reader = new FileReader()
    reader.onload = event => {
      let data
      try {
        data = JSON.parse(event.target.result)
      } catch (error) {
        return reject(error)
      }
      return resolve([data])
    }
    reader.readAsText(file)
  })

export default class JsonFileUpload extends Component {
  static propTypes = {
    onFilesUploaded: PropTypes.func.isRequired,
    maxItems: PropTypes.number,
    sortFiles: PropTypes.oneOf(['asis', 'asc', 'desc']),
    selectOnClick: PropTypes.bool,
    content: PropTypes.func.isRequired
  }

  constructor(...args) {
    super(...args)
    this.connectDropTarget = this.connectDropTarget.bind(this)
    this.onAssetFileDragEnter = this.onAssetFileDragEnter.bind(this)
    this.onAssetFileDragLeave = this.onAssetFileDragLeave.bind(this)
    this.acceptAssetFileDrop = this.acceptAssetFileDrop.bind(this)
    this.onAssetFileDrop = this.onAssetFileDrop.bind(this)
    this.inputFilesSelected = this.inputFilesSelected.bind(this)
    this.onDropFiles = this.onDropFiles.bind(this)

    this.dropAssetFileTarget = ADND.targets
      .files()
      .onDrop(this.onAssetFileDrop)
      .onEnter(this.onAssetFileDragEnter)
      .onLeave(this.onAssetFileDragLeave)
      .acceptDrop(this.acceptAssetFileDrop)
  }

  state = {
    dragOver: false,
    acceptFiles: true,
    progress: null
  }

  inputRef = React.createRef()

  connectDropTarget(ref) {
    this.dropAssetFileTarget.connect(ref)
  }

  componentDidMount() {
    this.mounted = true
  }

  componentWillUnmount() {
    this.mounted = false
    this.dropAssetFileTarget.disconnect()
  }

  onAssetFileDragEnter() {
    this.setState(state => {
      return {
        ...state,
        dragOver: true
      }
    })
  }

  onAssetFileDragLeave() {
    this.setState(state => {
      return {
        ...state,
        dragOver: false
      }
    })
  }

  acceptAssetFileDrop() {
    const { acceptFiles = true } = this.state
    return acceptFiles
  }

  onAssetFileDrop(...files) {
    if (files.length) {
      this.onDropFiles([files[0]])
    }
  }

  inputFilesSelected() {
    if (this.inputRef.current && this.inputRef.current.files && this.inputRef.current.files.length) {
      this.onDropFiles([this.inputRef.current.files[0]])
    }
  }

  onDropFiles(selectedFiles) {
    const { onFilesUploaded, sortFiles = 'asis' } = this.props

    const files =
      'asc' === sortFiles
        ? sortFilesByFilenames(selectedFiles, 1)
        : 'desc' === sortFiles
          ? sortFilesByFilenames(selectedFiles, -1)
          : selectedFiles

    if ('function' == typeof onFilesUploaded) {
      this.setState(
        state => {
          return {
            ...state,
            acceptFiles: false
          }
        },
        () => {
          processUploadedFile(files).then(files => {
            if (this.mounted) {
              this.setState(
                state => {
                  return {
                    ...state,
                    acceptFiles: true,
                    progress: null
                  }
                },
                () => {
                  onFilesUploaded(files)
                }
              )
            }
          })
        }
      )
    }
  }

  render() {
    const { content, selectOnClick = true } = this.props
    const { acceptFiles = true, dragOver, progress } = this.state
    return (
      <label
        className={`${style.component}${selectOnClick ? ' ' + style.selectOnClick : ''}`}
        ref={this.connectDropTarget}
      >
        {selectOnClick && acceptFiles ? (
          <input
            type="file"
            name="file"
            onChange={this.inputFilesSelected}
            accept="application/json"
            multiple={false}
            className={style.input}
            tabIndex="-1"
            ref={this.inputRef}
          />
        ) : null}
        {content ? content({ dragOver, progress, uploading: !acceptFiles }) : null}
      </label>
    )
  }
}

function sortFilesByFilenames(files, dir) {
  if (2 > files.length) {
    return files
  }
  const sortedIndexes = files
    .map((file, index) => {
      const fileName = 'string' == typeof file.name ? file.name || `file-${index}` : `file-${index}`
      const digitOrNotRegexp = /((\d+)|(\D+))/g
      const fileNameSplit = (fileName.match(digitOrNotRegexp) || []).map(part =>
        /^\d+$/.test(part) ? parseInt(part, 10) : part
      )
      return {
        fileNameSplit,
        index
      }
    })
    .sort((a, b) => {
      const maxLength = Math.max(a.fileNameSplit.length, b.fileNameSplit.length)
      for (let i = 0; i < maxLength; i++) {
        const currentFileNameSplitA = a.fileNameSplit[i] || ''
        const currentFileNameSplitB = b.fileNameSplit[i] || ''
        if (currentFileNameSplitA > currentFileNameSplitB) {
          return dir
        } else if (currentFileNameSplitA < currentFileNameSplitB) {
          return -dir
        }
      }
      return 0
    })
    .map(({ index }) => index)
  return sortedIndexes.map(index => files[index])
}
